@if (!isInIframe) {
  <div class="contenedor-footer">
    @if (isBrowser) {
      <!-- Quitamos el @if (dominios.length > 0) que borraba todo -->
      <div class="iframe">
        @for (item of dominios; track item) {
          <div class="scroll-escondido">
            <!-- Solo renderizamos el iframe si 'item' existe -->
            @if (item) {
              <iframe [src]="item" class="frame" frameborder="0" loading="lazy" referrerpolicy="no-referrer"></iframe>
            }
          </div>
        }

        <!-- Si el array está vacío, mantenemos al menos el hueco visual -->
        @if (dominios.length === 0) {
          <div class="iframe-placeholder">
            <p>Cargando cabeceras...</p>
          </div>
        }
      </div>
    } @else {
      <div class="iframe-placeholder">
        <p>Contenido se cargará en el navegador...</p>
      </div>
    }
  </div>
}
